import './index.css';
import { assetCategories } from './constants/assetCategories.js';
import SouzokuDiagnosisApp from './core/SouzokuDiagnosisApp.js';

/**
 * index画面エントリーポイント
 */
// アプリケーションインスタンス作成
const app = new SouzokuDiagnosisApp(assetCategories);

// 診断開始ボタンのイベント
const startBtn = document.querySelector('[data-ref="startBtn"]');
if (startBtn) {
  startBtn.addEventListener('click', () => {
    app.start();
  });
}